import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { StoreService } from '@core/services/store/store.service';
import { DateTimeFormat } from '@interticket/core';
import { DateTime } from 'luxon';

@Component({
  selector: 'datetime-offset',
  templateUrl: './datetime-offset.component.html',
  styleUrls: ['./datetime-offset.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatetimeOffsetComponent {

  readonly dateTimeFormat = DateTimeFormat;
  readonly displayTimezone: boolean = this.storeService.partnerConfig.localization.displayTimezone;

  @Input() date: DateTime;

  constructor(
    private storeService: StoreService
  ) { }

}
